class SpeiseplanerZubehoer extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.rows = Array.from(this.querySelectorAll('[data-zubehoer-row]'));
    this.atcButton = this.querySelector('[data-zubehoer-atc]');
    this.headerSale = this.querySelector('[data-zubehoer-header-sale]');
    this.headerCompare = this.querySelector('[data-zubehoer-header-compare]');
    this.headerBadge = this.querySelector('[data-zubehoer-header-badge]');
    this.variantId = parseInt(this.getAttribute('data-variant-id'), 10);
    this.available = this.getAttribute('data-available') === 'true';

    this.rows.forEach((row) => {
      row.addEventListener('click', () => this.selectRow(row));
    });

    this.atcButton?.addEventListener('click', () => this.addToCart());
    this.selectRow(this.rows.find((row) => row.classList.contains('is-selected')) || this.rows[0]);
  }

  getSelectedRow() {
    return this.rows.find((row) => row.classList.contains('is-selected')) || this.rows[0];
  }

  selectRow(row) {
    if (!row) return;
    this.rows.forEach((entry) => {
      const selected = entry === row;
      entry.classList.toggle('is-selected', selected);
      if (selected) {
        entry.setAttribute('aria-current', 'true');
      } else {
        entry.removeAttribute('aria-current');
      }
    });
    this.updateHeader(row);
  }

  updateHeader(row) {
    const finalFormatted = row.getAttribute('data-final-formatted') || '';
    const compareFormatted = row.getAttribute('data-compare-formatted') || '';
    const savingsCents = parseInt(row.getAttribute('data-savings-cents'), 10) || 0;
    const discountPercent = parseInt(row.getAttribute('data-discount-percent'), 10) || 0;

    if (this.headerSale) {
      const sr = this.headerSale.querySelector('.sr-only');
      this.headerSale.innerHTML = '';
      if (sr) this.headerSale.appendChild(sr);
      this.headerSale.append(document.createTextNode(finalFormatted.replace(/\u00a0/g, '\u00a0')));
      this.headerSale.classList.toggle('text-on-sale', savingsCents > 0);
      this.headerSale.classList.toggle('text-subdued', savingsCents <= 0);
    }

    if (this.headerCompare) {
      const sr = this.headerCompare.querySelector('.sr-only');
      this.headerCompare.innerHTML = '';
      if (sr) this.headerCompare.appendChild(sr);
      this.headerCompare.append(document.createTextNode(compareFormatted.replace(/\u00a0/g, '\u00a0')));
      this.headerCompare.hidden = savingsCents <= 0;
    }

    if (this.headerBadge) {
      if (savingsCents > 0 && discountPercent > 0) {
        this.headerBadge.hidden = false;
        this.headerBadge.textContent = `-${discountPercent}%`;
      } else {
        this.headerBadge.hidden = true;
        this.headerBadge.textContent = '';
      }
    }
  }

  async addToCart() {
    if (!this.available || !this.variantId || !this.atcButton) return;

    const row = this.getSelectedRow();
    const quantity = parseInt(row?.getAttribute('data-qty'), 10) || 1;
    const cartDrawerElement = document.querySelector('cart-drawer');
    const sectionId = cartDrawerElement?.getAttribute('data-section-id') || 'cart-drawer';
    let sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    if (!sectionsToBundle.includes(sectionId)) {
      sectionsToBundle.push(sectionId);
    }

    try {
      this.atcButton.setAttribute('aria-busy', 'true');
      this.atcButton.disabled = true;

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: this.variantId, quantity }],
          sections: sectionsToBundle.join(',')
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      const responseJson = await response.json();
      const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

      if (!responseJson.sections || !responseJson.sections[sectionId]) {
        const cartDrawerResponse = await fetch(`${window.Shopify.routes.root}cart?section_id=${sectionId}`);
        const cartDrawerHtml = await cartDrawerResponse.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartDrawerHtml;
        const newCartDrawer = tempDiv.querySelector('#cart-drawer');
        if (newCartDrawer) {
          if (!responseJson.sections) responseJson.sections = {};
          responseJson.sections[sectionId] = newCartDrawer.outerHTML;
        }
      }

      if (!cartContent.sections) cartContent.sections = {};
      cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

      const productForm = document.querySelector('form[is="product-form"]');
      const formToUse = productForm || document.createElement('form');
      let formAdded = false;
      if (!productForm) {
        document.body.appendChild(formToUse);
        formAdded = true;
      }

      formToUse.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          cancelable: true,
          detail: {
            items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
            cart: cartContent
          }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        })
      );

      if (formAdded) document.body.removeChild(formToUse);
    } catch (error) {
      console.error('Error adding Speiseplaner Zubehör to cart:', error);
    } finally {
      this.atcButton.removeAttribute('aria-busy');
      this.atcButton.disabled = !this.available;
    }
  }
}

if (!customElements.get('speiseplaner-zubehoer')) {
  customElements.define('speiseplaner-zubehoer', SpeiseplanerZubehoer);
}
